import * as React from 'react'
import { ReactElement } from 'react'
import DisbursementList from '../../../components/List/Disbursement/DisbursementList'
import { DisbursementOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'

export default function DisbursementOverview(props: RegistrationListProps<DisbursementOverviewDto>): ReactElement {
    return <DisbursementList {...props} />
}
